import { IAccountRequirementTemplatesGetParams } from 'CorePackage/AccountModule/actions/accountActions';

import { USER_REQUIREMENTS_PAGE_SIZE } from './useRequirementsPageSize';

export const initialRequirementTemplatesParams: IAccountRequirementTemplatesGetParams = {
  isCaching: false,
  order: '',
  page: '0',
  size: USER_REQUIREMENTS_PAGE_SIZE,
};
